import React, { Component } from 'react'
import { Box, Select, MenuItem } from '@mui/material'
export default class ShowEntries extends Component {
    /*** How to use:
     <ShowEntries value={this.state.limit} onChange={this.handleEntriesChange}/>

     handleEntriesChange(event) {
        this.setState({limit: event.target.value});
        setTimeout(() => this.fetchItems(), 100);
    }
     ***/

    constructor(props) {
        super(props)
    }

    render() {
        if (this.props.pager.pages <= 1 && this.props.pager.items <= 10) {
            return ''
        }

        let limit = parseInt(this.props.value)
        limit = limit < 0 || limit > 100 ? 50 : limit
        const pageSizes = [10, 20, 25, 50, 100]
        const options = pageSizes.includes(limit)
            ? pageSizes
            : [limit, ...pageSizes]

        return (
            <Box
                sx={{
                    float: 'right',
                }}
                className="show-entries"
            >
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    size="small"
                    name={'limit'}
                    value={limit}
                    onChange={(e) => {
                        this.props?.onChange ? this.props.onChange(e) : null
                    }}
                >
                    {options.map((pageSize) => (
                        <MenuItem key={pageSize} value={pageSize}>
                            {pageSize}
                        </MenuItem>
                    ))}
                </Select>
            </Box>
        )
    }
}
